import {
    TRIAL_USER_INITIATE,
    TRIAL_USER_REGISTER,
    TRIAL_USER_REGISTER_FAIL,
    TRIAL_USER_LOGIN,
    TRIAL_USER_ERROR,
    TRIAL_USER_VERIFY_LINK,
    VERIFY_CAPTCHA,
} from '../actions/TrialActions'

const initialState = {
    loading: false,
    message: null,
    trialRegDetails: {},
    trialLogDetails: {},
}

const trialReducer = function(state = initialState, action) {
    switch(action.type) {
        case TRIAL_USER_INITIATE:
            state = {
                ...state,
                loading:false,
                trialLogDetails: action.payload,
            }
            break

        case TRIAL_USER_LOGIN: 
            state = {
                ...state,
                loading:false,
                trialLogDetails: action.payload,
            }
            break
        
        
        case TRIAL_USER_ERROR: 
            state = {
                ...state,
                trialLogDetails: action.payload,
            }
            break

        case TRIAL_USER_REGISTER: 
            state = {
                ...state,
                loading:false,
                trialRegDetails: action.payload,
            }
            break

        case TRIAL_USER_REGISTER_FAIL: 
            state = {
                ...state,
                loading:false,
                trialRegDetails: action.payload,
            }
            break
        
        
        case TRIAL_USER_VERIFY_LINK:
            state = {
                ...state,
                userVerified: action.payload,
            }
            break
        case VERIFY_CAPTCHA:
            state = {
                ...state,
                captchaVerified: action.payload,
            }
            break
        
        default:
            state = {...state }
            break
    }
    return state
}

export default trialReducer